export default function SuggestedDrink(props) {
    const { product } = props;

    return (
        <div className="suggested-drink py-1 px-3 text-sm bg-grey-400">
            <p><span className="font-bold">Ottimo con:</span> {product.suggested_drink.name}</p>
        </div>
    );
}
